import Api from '@/services/Api'

import store from '../store/'

export default {
  Count(documentType, sinceUtc, filter) {
    let filterObj = null;
    if(filter)
      filterObj = JSON.parse(filter);
    else
      filterObj = [{name: "@type: " + documentType, facet: {key:"@type", value:documentType}}];
    return Api().post('/search', {
      filter: filterObj,
      searchString: '',
      orderBy: store.state.sortProperty,
      sortOrder: store.state.sortOrder,
      list: '',
      top: 0,
      sinceUtc: sinceUtc
    }).then( function (response) {
      return response.data.result.count;
    });
  },
  GetLatestUpdatesCount() {
    return Api().get('/api/v2/searchinfo/update')
  },
  GetAllResultsByFilter() {
    var searchfilter = [];
    if (store.state.filters.length > 0) {

      store.state.filters.forEach(function (f) {
        searchfilter.push(f);
      });
    } else {
      searchfilter = null;
    }
    return Api().post('/search/allresults', {
      filter: searchfilter,
      searchString: store.state.searchString,
      orderBy: store.state.sortProperty,
      sortOrder: store.state.sortOrder,
      list: store.state.searchList,
      sinceUtc: store.state.searchSinceUtc
    });
  },
  Search() {
    var searchfilter = [];
    // alert("ok: " + JSON.stringify(store.state.filters[0].filter));
    if (store.state.filters.length > 0) {

      store.state.filters.forEach(function (f) {
        searchfilter.push(f);
      });
    } else {
      searchfilter = null;
    }

    return Api().post('/search', {
      filter: searchfilter,
      searchString: store.state.searchString,
      orderBy: store.state.sortProperty,
      sortOrder: store.state.sortOrder,
      list: store.state.searchList,
      sinceUtc: store.state.searchSinceUtc
    });
  },
  ContinueSearch(token) {
    return Api().post('/search', token);
  },
  SearchFromList(list) {
    var searchfilter = [];

    if (store.state.filters.length > 0) {
      store.state.filters.forEach(function (f) {
        searchfilter.push(f);
      });
    } else {
      searchfilter = null;
    }

    return Api().post('/api/v2/searchlist', {
      filter: searchfilter,
      list: list
    });
  }
}
